import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchStoreService } from '@ecs-services/search/search-store.service';
import { HeaderLoginService, OnDestroyBase } from '@os-components';
import { filter, takeUntil } from 'rxjs/operators';
import { SearchInputComponent } from './components/search-input/search-input.component';

export const SEARCH_STRING_PARAM = 'SEARCH_STRING';

@Component({
    selector: 'ecs-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [SearchInputComponent],
})
export class SearchComponent extends OnDestroyBase implements OnInit, OnDestroy {
    public constructor(
        private searchStore: SearchStoreService,
        private route: ActivatedRoute,
        private userService: HeaderLoginService
    ) {
        super();
    }

    public ngOnInit(): void {
        const queryParams = this.route.snapshot.queryParamMap;

        this.userService.user
            .pipe(
                filter((user) => user !== undefined),
                takeUntil(this.destroySubject)
            )
            .subscribe(() => this.searchStore.fetchSearchHistory());

        const searchTerm = queryParams.get(SEARCH_STRING_PARAM);
        if (searchTerm) {
            this.searchStore.search(searchTerm);
        }
    }
}
